export default __webpack_public_path__ + "static/media/rxdb.2ea320e4.svg";